import * as React from "react";
import ReactSlider from "react-slider";
import styled, { css } from "styled-components";
import { Input } from "components/bootstrap";
import Tooltip from "components/common/Tooltip";
const StyledSlider = styled(ReactSlider)(
  ({ theme }) => css`
    width: 100%;
    height: 10px;
    margin: ${theme.spacings.md} 0;
  `
);
const StyledThumb = styled.div(
  ({ theme }) => css`
    height: auto;
    min-height: 25px;
    line-height: 25px;
    width: auto;
    min-width: 25px;
    text-align: center;
    background-color: #5082bc;
    color: ${theme.colors.input.color};
    border-radius: 50%;
    cursor: grab;
    top: -5px;
  `
);
const Thumb = ({ ...props }, state) => /* @__PURE__ */ React.createElement(StyledThumb, { ...props, className: `${state.valueNow}-tooltip` }, /* @__PURE__ */ React.createElement(Tooltip, { label: state.valueNow }, /* @__PURE__ */ React.createElement("span", { className: "value" }, state.valueNow)));
const StyledTrack = styled.div(
  ({ theme, $index }) => css`
    top: ${theme.spacings.xxs};
    bottom: 0;
    background: ${$index === 1 ? "#5082bc" : theme.colors.variant.default};
    border-radius: 999px;
  `
);
const Track = (props, state) => /* @__PURE__ */ React.createElement(StyledTrack, { ...props, $index: state.index });
const RangeInput = ({
  id,
  label = void 0,
  help = void 0,
  error = void 0,
  bsStyle = void 0,
  labelClassName = void 0,
  wrapperClassName = void 0,
  ...otherProps
}) => /* @__PURE__ */ React.createElement(
  Input,
  {
    labelClassName,
    id,
    wrapperClassName,
    help,
    bsStyle,
    error,
    label
  },
  /* @__PURE__ */ React.createElement(StyledSlider, { renderTrack: Track, renderThumb: Thumb, className: error, ...otherProps })
);
export default RangeInput;
